import React, { useState } from "react";
import { Grid2 as Grid } from '@mui/material';
import { AddBusiness } from '@mui/icons-material';
import { BoxSpaceCenter } from "../style/box";
import { RegisterButton } from "../style/button";
import { TypographyBold } from '../style/typography';
import CommonCard from '../components/common_card';
import { CustomControlledInput } from "./CustomControlledInput";

const DepartmentUpdate = ({ title, control, department, openDialog, trigger, getValues, isDisabled }) => {
    return (
        <Grid size={{ xs: 12 }}>
            <CommonCard
                child={
                    <Grid container spacing={3} sx={{ padding: 3 }}>
                        <Grid size={{ xs: 12 }}>
                            <TypographyBold>{title}</TypographyBold>
                        </Grid>
                        {/* 部署名 */}
                        <Grid size={{ xs: 12 }}>
                            <CustomControlledInput
                                name="editDepartment.name"
                                control={control}
                                label="部署名"
                                variant="outlined"
                                inputProps={{ maxLength: 100 }}
                                disabled={isDisabled}
                            />
                        </Grid>
                        {/* 登録ボタン */}
                        <Grid container size={{ xs: 12 }} justifyContent="center">
                            <Grid size={{ xs: 12, md: 6 }}>
                                <BoxSpaceCenter>
                                    <RegisterButton
                                        fullWidth
                                        variant="contained"
                                        startIcon={<AddBusiness />}
                                        disabled={isDisabled}
                                        onClick={async () => {
                                            // バリデーションチェック
                                            const isValid = await trigger("editDepartment.name");
                                            if (!isValid) return; // バリデーションエラーならダイアログを開かない

                                            // バリデーションOKならダイアログを開く
                                            const name = getValues("editDepartment.name");
                                            openDialog("save", { name, uuid: department?.uuid });
                                        }}
                                    >
                                        部署名を更新
                                    </RegisterButton>
                                </BoxSpaceCenter>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            />
        </Grid>

    );
};

export default DepartmentUpdate;